import { Icon, IconProps } from '@chakra-ui/react'

export default function ManagementSessionsIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M5.332 5.332h-.861a2 2 0 00-.895.212l-.39.195a2 2 0 00-.821.76L1.33 8.222M12.668 8.667h-1.333M12.669 10.668H10M1.998 14.002l3.842-1.388a2.668 2.668 0 001.313-1.029L9.15 8.592a1.098 1.098 0 00-.137-1.385v0a1.098 1.098 0 00-1.552 0L6 8.667H4.664"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.332 12.798v.204a1 1 0 001 1h7.337a1 1 0 001-1V2.998a1 1 0 00-1-1H6.332a1 1 0 00-1 1v5.669"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M13.334 4.133a.2.2 0 00-.2-.2h-.4v-.4a.2.2 0 00-.2-.2h-.4a.2.2 0 00-.2.2v.4h-.4a.2.2 0 00-.2.2v.4c0 .11.09.2.2.2h.4v.4c0 .11.09.2.2.2h.4a.2.2 0 00.2-.2v-.4h.4a.2.2 0 00.2-.2v-.4z"
        stroke="currentColor"
        strokeWidth={0.59975}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
